import React, { useContext } from 'react';
import { TypeUserStatus } from '../typeUserStatus';
import { ExchangesPageContext } from 'page/exchangeReport/index';
import { corDaSituacao, familiaPeloCodigo } from 'utils/situacao';

const TITULO_POR_CODIGO = {
  31: 'Solicitado',
  32: 'Confirmado',
  33: 'Ocorrendo',
  34: 'Realizado',
  35: 'Cancelado',
  38: 'Cancelado',
};

export const ContainerUserStatus = () => {
  const { details } = useContext(ExchangesPageContext);

  const codigo = `${details?.situation}${details?.situation_status}`;
  const titulo = TITULO_POR_CODIGO[codigo];

  if (!titulo) return <></>;

  return (
    <TypeUserStatus
      cor={corDaSituacao(familiaPeloCodigo(codigo)).solido}
      titleStatus={titulo}
    />
  );
};
